import * as types from "./actions.types";
import { Action } from "./actions";
import { IAuthStore } from "./types";
import SessionService from "../../services/SessionService";

const initialState: IAuthStore = {
  isLoggedIn: SessionService.getIsLoggedfromLS() === 'true' ? true : false
};

const authReducer = (
  state: IAuthStore = initialState,
  action: Action
): IAuthStore => {
  switch (action.type) {
    case types.LOG_IN:
      return {
        ...state,
        isLoggedIn: true
      };
    case types.LOG_OUT: {
      return {
        ...state,
        isLoggedIn: false
      };
    }
    default:
      return state;
  }
};

export default authReducer;
